import { render, staticRenderFns } from "./SelectReviewerFilter.vue?vue&type=template&id=2aa170e4&scoped=true"
import script from "./SelectReviewerFilter.vue?vue&type=script&lang=js"
export * from "./SelectReviewerFilter.vue?vue&type=script&lang=js"
import style0 from "./SelectReviewerFilter.vue?vue&type=style&index=0&id=2aa170e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa170e4",
  null
  
)

export default component.exports